module.exports = __webpack_public_path__ + "img/qlearning-practice.72363a56.png";